/**
 * The empty-state line a query tile shows when its run returns 0 rows (D5).
 * S7 templates seed a healthy-empty message ("No sessions are currently
 * blocked.") so 0 rows reads as good news, not a broken tile; hand-authored
 * tiles carry no copy and fall back to the caller's generic default.
 */
export const tileEmptyText = (
  tile: { emptyStateCopy?: string },
  fallback: string,
): string => tile.emptyStateCopy?.trim() || fallback;
